/** Build target: `web` (default), `ios`, or `android` (Capacitor shells). */
export const APP_TARGET = import.meta.env.VITE_APP_TARGET ?? "web";

export const IS_IOS_APP = APP_TARGET === "ios";
export const IS_ANDROID_APP = APP_TARGET === "android";
// Dev-only override: localStorage.setItem("pawseum:appTarget", "android"); location.reload()
const _devTarget = import.meta.env.DEV
  ? localStorage.getItem("pawseum:appTarget")
  : null;
export const IS_NATIVE_APP = IS_IOS_APP || IS_ANDROID_APP || !!_devTarget;

/** Informative-only routes omitted from all native app binaries (see PRD appendix B).
 * `/planos` is also blocked as defense-in-depth — paid tier UI must never be
 * reachable on native while StoreKit/Play Billing IAP isn't wired (App Store 3.1.1 /
 * Google Play Billing §3.1). useFeatureFlags also forces `paid_tiers` off on native,
 * but the redirect here guarantees a deep link can't expose it. */
export const NATIVE_BLOCKED_ROUTE_PREFIXES = [
  "/tutorial-dono",
  "/porque-adotar",
  "/sobre-pawseum",
  "/blog",
  "/planos",
] as const;

/** @deprecated Use NATIVE_BLOCKED_ROUTE_PREFIXES */
export const IOS_BLOCKED_ROUTE_PREFIXES = NATIVE_BLOCKED_ROUTE_PREFIXES;

export function isNativeBlockedPath(pathname: string): boolean {
  return NATIVE_BLOCKED_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** @deprecated Use isNativeBlockedPath */
export const isIosBlockedPath = isNativeBlockedPath;
